export { default } from './FAQsPage';
